import { render, staticRenderFns } from "./2_PersonalStep.vue?vue&type=template&id=09d76d59&scoped=true&"
import script from "./2_PersonalStep.vue?vue&type=script&lang=js&"
export * from "./2_PersonalStep.vue?vue&type=script&lang=js&"
import style0 from "./2_PersonalStep.vue?vue&type=style&index=0&id=09d76d59&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09d76d59",
  null
  
)

export default component.exports